(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.factory('timeResolutions', function () {
        var data = [
            {
                id: 'minute',
                label: 'Minute',
                pastLabel: 'Last 60 sec',
                seconds: 60,
                format: 'HH:mm',
                step: 'second',
                stepMax: 60,
                stepFormat: 'HH:mm:ss'
            },
            {
                id: 'hour',
                label: 'Hour',
                pastLabel: 'Last 60 min',
                seconds: 60 * 60,
                format: 'HH:mm',
                step: 'minute',
                stepMax: 60,
                stepFormat: 'HH:mm'
            },
            {
                id: 'day',
                label: 'Today',
                pastLabel: 'Last 24h',
                seconds: 24 * 60 * 60,
                format: 'MMM DD',
                step: 'hour',
                stepMax: 24,
                stepFormat: 'HH:mm'
            },
            {
                id: 'week',
                label: 'Week',
                pastLabel: 'Last 7 days',
                seconds: 7 * 24 * 60 * 60,
                format: 'MMM DD',
                step: 'day',
                stepMax: 7,
                stepFormat: 'MMM DD'
            },
            {
                id: 'month',
                label: 'Month',
                pastLabel: 'Last 30 days',
                seconds: 30 * 24 * 60 * 60,
                format: 'MMM DD',
                step: 'day',
                stepMax: 30,
                stepFormat: 'MMM DD'
            },
            {
                id: 'year',
                label: 'Year',
                pastLabel: 'Last 12 months',
                seconds: 365 * 24 * 60 * 60,
                format: 'YYYY',
                step: 'month',
                stepMax: 12,
                stepFormat: 'MMM DD'
            }
        ];
        return {
            data: data,
            dataPastLabel: _(data).map(function (variant) {
                return $.extend({}, variant, { label: variant.pastLabel });
            }),
            get: function (id) {
                return _(data).find(function (res) {
                    return res.id == id;
                });
            }
        };
    });
}());